// extracted by mini-css-extract-plugin
export var RelatedArticles = "related-categories-module--RelatedArticles--5133d";
export var RelatedHubList = "related-categories-module--RelatedHubList--2df13";
export var RelatedHubs = "related-categories-module--RelatedHubs--ee533";
export var RelatedHubsWrapper = "related-categories-module--RelatedHubsWrapper--ba8a8";
export var RelatedTitleWrapper = "related-categories-module--RelatedTitleWrapper--f63ff";
export var RelatedWrapperInner = "related-categories-module--RelatedWrapperInner--94cf9";